export default {
  // FrontPage.vue
  frontPageRequirementTitle: 'Suche',
  frontPageProvideTitle: 'Biete',
  frontPagePersonalCenterTitle: 'Profil',
  login: 'Anmelden',
  home_chatWithOctopie: 'Deine Gedanken werden verstanden',
  home_chatNeedUnderstood: 'Deine Gedanken wurden verstanden',
  home_draftBannerTitle: 'Nachricht fertigstellen',
  home_draftBannerSubtitle: 'Die KI hat deine Nachricht schon vorbereitet — tippe, um fortzufahren',
  home_tabHome: 'Start',

  // App.vue
  appRequirementTitle: 'Wir hören auf jeden Vorschlag und jedes Feedback',
  appRequirementBtn: 'Absenden',
  appSubmitSuccess: 'Erfolgreich gesendet, danke für dein Feedback',
  appFeedbackLink: 'Feedback/Vorschläge',
  mobile_banner_text: 'Für das beste Erlebnis nutze unsere App',
  mobile_banner_btn: 'App holen',

  // Common
  loading: 'Lädt...',
  confirm: 'Bestätigen',
  cancel: 'Abbrechen',
  save: 'Speichern',
  delete: 'Löschen',
  edit: 'Bearbeiten',
  add: 'Hinzufügen',
  search: 'Suchen',
  refresh: 'Aktualisieren',
  change_batch: 'Neu mischen',
  back: 'Zurück',
  submit: 'Absenden',
  close: 'Schließen',
  ok: 'OK',
  yes: 'Ja',
  no: 'Nein',
  send: 'Senden',
  block: 'Blockieren',
  more: 'Mehr',
  logout: 'Abmelden',
  settings: 'Einstellungen',
  view_guide: 'Anleitung ansehen',
  feedback: 'Feedback',
  feedback_title: 'Feedback',
  feedback_new: 'Neues Feedback',
  feedback_empty: 'Noch kein Feedback',
  feedback_hint: 'Sag uns, was du denkst...',
  feedback_submit: 'Absenden',
  feedback_submit_success: 'Feedback erfolgreich gesendet',
  feedback_submit_failed: 'Feedback konnte nicht gesendet werden',
  feedback_reply_label: 'Antwort der Plattform',
  register: 'Registrieren',
  name: 'Name',
  email: 'E-Mail',
  mobile: 'Handynummer',
  password: 'Passwort',
  verification_code: 'Bestätigungscode',
  company_name: 'Beijing Liangshao Technology Co., Ltd.',
  all_rights_reserved: 'Alle Rechte vorbehalten.',
  footerVersion: 'Version {version}',
  copy: 'Kopieren',
  regenerate: 'Neu generieren',
  generate: 'Generieren',
  contact_now: 'Chatten',
  yours: 'deine',
  xiaoyao_analysis: 'KI-Analyse',
  brand_name: 'OctoSay',
  anonymous: 'Anonym',
  no_summary: 'Keine Zusammenfassung',
  file: 'Datei',
  discover: 'Entdecken',
  discover_title: 'Entdecken',
  discover_hotChannels: 'Beliebte Kanäle',
  discover_allChannels: 'Alle',
  discover_searchChannel: 'Kanal suchen',
  discover_noChannels: 'Keine Kanäle gefunden',

  // Messages
  operationSuccess: 'Aktion erfolgreich',
  operationFailed: 'Aktion fehlgeschlagen',
  networkError: 'Netzwerkfehler, bitte später erneut versuchen',
  dataLoadingFailed: 'Daten konnten nicht geladen werden',
  noData: 'Keine Daten',
  deleteConfirm: 'Möchtest du wirklich löschen?',
  saveConfirm: 'Möchtest du wirklich speichern?',

  // Form Validation
  required: 'Dieses Feld ist erforderlich',
  emailInvalid: 'Bitte gib eine gültige E-Mail-Adresse ein',
  phoneInvalid: 'Bitte gib eine gültige Telefonnummer ein',
  passwordTooShort: 'Das Passwort muss mindestens {min} Zeichen lang sein',
  passwordMismatch: 'Die Passwörter stimmen nicht überein',

  // Time
  today: 'Heute',
  yesterday: 'Gestern',
  justNow: 'Gerade eben',
  minutesAgo: 'vor {min} Minuten',
  hoursAgo: 'vor {hour} Stunden',
  daysAgo: 'vor {day} Tagen',

  // Footer
  about: 'Über',
  footerPrivacy: 'Datenschutz',
  footerTerms: 'Nutzungsbedingungen',
  footerSupport: 'Hilfe & Support',

  // Register
  registerAgeConfirm: 'Ich bestätige, dass ich mindestens 13 Jahre alt bin',
  registerAgeConfirm18: 'Ich bestätige, dass ich mindestens 18 Jahre alt bin',
  registerTermsPrefix: 'Ich habe folgende Dokumente gelesen und stimme zu: ',
  registerTermsAnd: ' und ',
  registerAgeError: 'Bitte bestätige dein Alter',
  registerTermsError: 'Bitte akzeptiere die Nutzungsbedingungen und die Datenschutzerklärung',

  // Chat
  chatPrivacyTip: 'Schreibe deine Nachricht in den Gruppe und die KI chattet zuerst mit dir, um Einzelheiten zu klären. Nach deiner Bestätigung werden Nachricht und KI-Zusammenfassung zusammen veröffentlicht und AI sucht weiter nach Matches.',
  aiChat_quickSuggestions: 'Sag mal',
  aiChat_welcome: "Hey! Sag mir, wonach du suchst.",

  // Chat - AI Progress Steps (new)
  aiChat_readyToPost: 'Details verstanden — poste, um dein Match zu finden',
  aiChat_readyToPostHint: 'Chatte weiter, um jederzeit Details hinzuzufügen oder die Zusammenfassung zu aktualisieren',
  aiChat_progressStep1: 'Details verstehen',
  aiChat_progressStep1Done: 'Details verstanden',
  aiChat_progressStep2: 'KI-Zusammenfassung',
  aiChat_progressStep2Desc: 'AI erstellt eine Zusammenfassung fürs Matching',
  aiChat_progressStep3: 'Im Gruppe posten',
  aiChat_progressStep3Desc: 'Posten und dein Match finden',
  aiChat_publishExtraHint: 'Gib deine Nachricht an den Gruppe ein',
  aiChat_publishMsgRequired: 'Erforderlich',
  aiChat_publishMsgLabel: 'Deine Nachricht an den Gruppe',
  aiChat_matchSummaryLabel: 'KI-Zusammenfassung',

  ai_generated_label: 'AI Generated',

  ai_content_disclaimer: 'Der folgende Inhalt wurde von AI generiert und dient nur als Referenz.',
  aiChat_publishSuggestionHint: 'Zum Ersetzen antippen',
  aiChat_allowDirectContact: 'Direkten Kontakt erlauben',
  aiChat_allowDirectContactDesc: 'Andere können dich ohne Match direkt kontaktieren',
  channel_chat_session_publishToChannel: 'Im Octo-Gruppe posten',
  aiChat_newChat: 'Zurücksetzen',

  // Channels / Gruppen
  home_tabChannels: 'Octo-Gruppen',
  channels_title: 'Octo-Gruppen',
  channels_myChannels: 'Beigetretene Gruppen',
  channels_discover: 'Entdecken',
  channels_noChannels: 'Noch keine Gruppen',
  channels_noMyGroupsTitle: 'Du bist noch keinem Gruppe beigetreten',
  channels_noMyGroupsSubtitle: 'Suche einen Gruppe zum Beitreten und starte neue Kontakte',
  channels_searchGroupsBtn: 'Gruppen suchen',
  channels_loginPrompt: 'Bitte melde dich an, um Gruppen zu sehen',
  channels_create: 'Octo-Gruppe erstellen',
  channels_search: 'Octo-Gruppen suchen',
  channels_searchMyGroups: 'Meine Octo-Gruppen durchsuchen',
  channels_searchHint: 'Suchen',
  channels_searchHintChats: 'Chats durchsuchen...',
  channels_searchHintGroups: 'Gruppen suchen...',
  channels_searchHintMy: 'Beigetretene Gruppen durchsuchen...',
  channels_joinByCode: 'Mit Code beitreten',
  channels_joinByCodeTitle: 'Octo-Gruppe per Code beitreten',
  channels_joinByCodeHint: 'Octo-Gruppe-Code eingeben',
  channels_joinByCodeConfirm: 'Beitreten',
  channels_joinByCodeNotFound: 'Gruppe nicht gefunden',
  channels_createNewGroup: 'Neuen Octo-Gruppe erstellen',
  channels_noResults: 'Keine Gruppen gefunden',
  channel_detail_join: 'Beitreten',
  channel_detail_leave: 'Verlassen',
  channel_detail_members: 'Mitglieder',
  // 聚合进群消息 banner（joinMsgs）
  channelJoinMsg_oneJoined: '{name} ist dem Hub beigetreten',
  channelJoinMsg_twoJoined: '{name1} und {name2} sind dem Hub beigetreten',
  channelJoinMsg_multiJoined: '{name1}, {name2} und {n} weitere sind dem Hub beigetreten',
  channelJoinMsg_oneAndMoreJoined: '{name} und {n} weitere sind dem Hub beigetreten',
  channelJoinMsg_membersJoined: '{n} Mitglieder sind dem Hub beigetreten',

  // Feed
  channels_feed: 'Chats',
  channels_groups: 'Gruppen',
  feed_related: 'Ähnlich',
  feed_recommend: 'Empfohlen',
  feed_empty: 'Noch kein Feed, entdecke beliebte Gruppen',
  feed_goToGroup: 'Im Gruppe ansehen',
  feed_joinGroupAndSendMsg: 'Tritt einem Gruppe bei und sende eine Nachricht',
  channel_detail_channelCode: 'Octo-Gruppe-Code',
  channel_detail_invitePhrase: 'Einladung zu "{name}"\nEinladungscode {code} – App öffnen und automatisch beitreten · Die KI klärt zuerst und findet die richtigen Leute',
  channel_detail_post: 'Im Gruppe posten',
  channel_detail_aiHint: "Schreib deine Nachricht in den Gruppe und AI klärt zuerst die Details",
  channel_input_hint: 'Sag etwas...',
  channel_leave_confirm_message: 'Möchtest du diesen Gruppe wirklich verlassen? Du erhältst keine Gruppe-Nachrichten mehr.',
  channel_invite_notFound: 'Gruppe nicht gefunden oder Link abgelaufen',
  channel_invite_joinBtn: 'OctoSay App herunterladen',
  channel_invite_hint: 'Lade die App herunter, scanne dann diesen QR-Code oder suche den Gruppe-Namen, um beizutreten',
  channel_invite_globalHintTitle: 'Du lädst gerade die globale Version herunter',
  channel_invite_globalHintIOS: 'Diese App ist im chinesischen App Store eventuell nicht verfügbar. Wechsle zu einem Apple Store außerhalb Chinas und suche OctoSay, oder lade die APK direkt unten herunter.',
  channel_invite_globalHintAndroid: 'Google Play ist in deiner Region eventuell nicht zugänglich. Wir empfehlen, die APK direkt herunterzuladen, oder versuche Google Play.',
  channel_invite_globalHintDefault: 'Die App ist in deinem lokalen App Store eventuell nicht verfügbar. Wir empfehlen, die APK direkt herunterzuladen, oder versuche den App Store.',
  channel_invite_globalBtnAppStore: 'Zum App Store',
  channel_invite_globalBtnGooglePlay: 'Zu Google Play',
  channel_invite_globalBtnAPK: 'APK direkt herunterladen',
  channel_invite_defaultDesc: 'Tritt {name} auf OctoSay bei',
  share: 'Teilen',
  share_channel: 'Gruppe teilen',
  share_channel_link: 'Link teilen',
  channel_detail_inviteCode: 'Einladungscode',
  channel_detail_copyLink: 'Link kopieren',
  share_session_title: 'Ein Beitrag auf OctoSay',
  share_match_title: 'Ein Match auf OctoSay',
  share_session_text: '{userName}: {summary}',
  share_session_text_no_summary: 'Sieh dir an, was {userName} auf OctoSay gepostet hat',
  session_share_notFound: 'Beitrag nicht gefunden oder Link abgelaufen',
  session_share_fromChannel: 'Vom Octo-Gruppe',
  session_share_downloadBtn: 'OctoSay App herunterladen',
  session_share_hint: 'Lade die App herunter, um den vollen Beitrag zu sehen und dem Gruppe beizutreten',
  session_share_openInApp: 'In App öffnen',
  toast_link_copied: 'Link kopiert',
  toast_no_share_data: 'Nichts zum Teilen',
  channels_joinByQR: 'QR-Code',
  channels_joinByQRWebHint: 'Das Web unterstützt keinen QR-Scan. Bitte gib den Gruppe-Code ein, um beizutreten.',
  channels_joinByQRTitle: 'Mit QR-Code beitreten',
  channel_detail_qrCode: 'QR-Code',
  channel_detail_qrCodeSave: 'Bild speichern',
  channel_detail_qrCodeSaveHint: 'Rechtsklick auf das Bild zum Speichern',
  channel_detail_qrCodeSaved: 'Im Album gespeichert',
  channel_detail_qrCodeSaveFailed: 'Speichern fehlgeschlagen, bitte erneut versuchen',
  channel_detail_locateFailed: 'Nachricht konnte nicht gefunden werden',
  channel_detail_locateError: 'Fehler beim Auffinden der Nachricht',
  channel_detail_myMessages: 'Meine Nachrichten',
  channel_detail_searchMessages: 'Nachrichten durchsuchen',
  channel_detail_aiChat: 'AI Chat',
  channel_detail_matchHistory: 'Match-Verlauf',
  channel_create_title: 'Octo-Gruppe erstellen',
  channel_create_name: 'Octo-Gruppe-Name',
  channel_create_description: 'Beschreibung',
  channel_create_submit: 'Erstellen',
  channelCreate_aiAssist: 'AI hilft dir, einen passenden Gruppe zu erstellen',
  channelCreate_nameHint: 'Gib einen Namen für deinen Gruppe ein',
  channelCreate_descHint: 'Beschreibe, worum es in deinem Gruppe geht',
  channelCreate_creating: 'Wird erstellt...',
  channelCreate_created: 'Gruppe erstellt!',
  channelCreate_failed: 'Gruppe konnte nicht erstellt werden',
  channelCreate_welcomeMsg: "Hi! Ich helfe dir dabei, einen Gruppe zu erstellen. Sag mir, welchen Gruppe du möchtest – Thema oder Zweck – und ich mache daraus einen Gruppe-Namen und eine Einführung und erstelle außerdem einen Avatar.",
  channelCreate_aiHint: 'Schreibe dein Gruppe-Thema...',
  channelCreate_clarifyingProgress: 'Dein Gruppe-Thema wird sortiert...',
  channelCreate_readyToCreate: 'Bereit, den Octo-Gruppe zu erstellen',
  channelCreate_step1: 'Thema beschreiben',
  channelCreate_step1Done: 'Idee geklärt',
  channelCreate_step2: 'Octo-Gruppe erstellen',
  channelCreate_confirmBtn: 'Erstellung bestätigen',
  channelCreate_publicNotice: "Gruppen sind öffentliche Räume, in denen sich Menschen mit gemeinsamen Interessen treffen und vernetzen. Die Plattform kann Gruppen nach Bedarf verwalten, aktualisieren oder zusammenführen. Teile diesen Gruppe gern mit anderen, die sich dafür interessieren könnten.",
  channelCreate_similarGroupsTitle: 'Ähnliche Octo-Gruppen gefunden',
  channelCreate_similarGroupsDesc: 'Diese Gruppen könnten zu dir passen',
  channelCreate_exactMatchHint: 'Ein Gruppe mit genau diesem Namen existiert bereits!',
  channelCreate_joinHint: 'Diese bestehenden Gruppen könnten gut passen',
  channelCreate_joinExisting: 'Bestehendem Octo-Gruppe beitreten',
  channelCreate_stillCreate: 'Trotzdem neuen Octo-Gruppe erstellen',
  channel_chat_session_comments: 'Kommentare',
  channel_chat_session_commentHint: 'Schreibe einen Kommentar...',
  channel_chat_session_sendComment: 'Kommentieren',
  channel_chat_session_loadMore: 'Mehr laden',
  channel_chat_session_noComments: 'Noch keine Kommentare',
  channel_chat_session_deleteComment: 'Löschen',
  channelSearch_title: 'Im Gruppe suchen',
  channelSearch_placeholder: 'Nachrichten durchsuchen...',
  channelSearch_onlyMine: 'Nur meine Beiträge',
  channelSearch_tabAllMessages: 'Gruppe-Nachrichten',
  channelSearch_tabMyMessages: 'Meine Nachrichten',
  chatMsgSearch_placeholder: 'Nachrichten durchsuchen',
  chatMsgSearch_tabMsgs: 'Nachrichten',
  chatMsgSearch_tabContacts: 'Kontakte',
  chatMsgSearch_emptyPrompt: 'Tippe Stichwörter ein, um Nachrichten zu durchsuchen',
  chatMsgSearch_tooShort: 'Tippe mindestens 2 Zeichen ein, um zu suchen',
  chatMsgSearch_contactEmptyPrompt: 'Tippe einen Nutzernamen oder eine E-Mail ein, um Kontakte zu suchen',
  chatMsgSearch_noContacts: 'Keine passenden Kontakte',
  chatMsgSearch_inChatPlaceholder: 'In diesem Chat suchen',
  channelHistory_title: 'Verlauf',
  channelHistory_myMessages: 'Meine Nachrichten',
  channelHistory_loadMore: 'Mehr laden',
  channel_settings_push: 'Octo-Gruppe-Benachrichtigungen',
  channel_settings_commentPush: 'Kommentar-Benachrichtigungen',
  channel_settings_likePush: 'Like-Benachrichtigungen',
  channel_settings_receiveNotifications: 'Benachrichtigungen erhalten',
  channel_settings_directContact: 'Direkten Kontakt erlauben',
  session_published: 'Veröffentlicht',
  session_publishFailed: 'Veröffentlichen fehlgeschlagen',
  session_setDirectContactSuccess: 'Einstellung gespeichert',
  session_setDirectContactFailed: 'Einstellung konnte nicht gespeichert werden',
  session_setPrivate: 'Privat stellen',
  session_setPublic: 'Öffentlich stellen',
  session_pauseMatching: 'Matching pausieren',
  session_resumeMatching: 'Matching fortsetzen',
  session_matchPausedToast: 'Matching pausiert',
  session_matchResumedToast: 'Matching fortgesetzt',
  match_matchingPausedTitle: 'Matching ist pausiert',
  match_reasonTag: 'Match-Grund',
  match_matchingPausedHint: 'Du kannst das Matching jederzeit fortsetzen.',
  session_confirmSetPrivate: 'Diesen Inhalt privat stellen? Andere Nutzer können ihn dann nicht sehen.',
  session_messageIsPrivate: 'Diese Nachricht ist privat',
  chatSessionComment_replyHint: 'Schreibe einen Kommentar...',
  chatSessionComment_reply: 'Kommentieren',
  chatSessionComment_count: '{n} Kommentar | {n} Kommentare',
  chatSessionMatch_count: '{n} Match | {n} Matches',
  chatSessionComment_replyTo: 'Antworten',
  chatSessionComment_inputHint: 'Schreibe einen Kommentar...',
  chatSessionComment_send: 'Senden',
  chatSessionComment_delete: 'Löschen',
  chatSessionComment_deleteConfirm: 'Möchtest du diesen Kommentar wirklich löschen?',
  chatSessionComment_loadMore: 'Mehr laden',
  chatSessionComment_noMore: 'Keine weiteren Kommentare',
  chatSessionComment_loginToComment: 'Melde dich an, um zu kommentieren',
  chatSessionComment_viewEarlier: '{n} frühere Antworten anzeigen',
  chatSessionLike_like: 'Gefällt mir',
  chatSessionLike_liked: 'Gefällt dir',
  chatSessionLike_count: 'Gefällt-mir',
  chatSessionBookmark_bookmark: 'Speichern',
  chatSessionBookmark_bookmarked: 'Gespeichert',
  chatSessionMatch_viewMatches: 'Matches ansehen',
  chatSessionMatch_matchHistory: 'Match-Verlauf',
  chatSessionMatch_noMatches: 'Noch keine Matches',
  channel_match_achievement: '{count} Beiträge erfolgreich vermittelt',
  channel_match_achievement_view: 'Ansehen →',
  channel_matchHistory_title: 'Kanal-Match-Verlauf',
  chatSessionMatch_matchedAt: 'Gematcht um {time}',
  discover_userMsgLabel: 'Nutzer sagte',
  common_loading: 'Lädt...',
  common_sending: 'Wird gesendet...',
  common_error: 'Fehler',
  common_success: 'Erfolg',
  common_me: 'Ich',

  // Chat - Set Public / Pick Location
  aiChat_clarifyingProgress: "Die KI klärt dein Anliegen, damit deine Nachricht wirklich wirkt — nach dem Posten matcht sie weiter für dich",
  aiChat_clarifyingAlmostDone: 'Fast geschafft, bitte bestätigen',
  aiChat_clarifyingOneMore: 'Noch ca. 1 Frage, dann kannst du posten',
  aiChat_clarifyingRemaining: 'Noch ca. {count} Runden, fast geschafft',
  aiChat_clarifyingEvaluating: 'Fortschritt wird bewertet...',
  aiChat_setPublicMatch: 'Öffentlich stellen & matchen',
  aiChat_needsClarifiedPublic: "Ich verstehe dich jetzt. Sobald du bestätigst und postest, matcht AI weiter für dich.\nTeile jederzeit gern mehr Details.",
  aiChat_needsClarifiedPrivate: 'Verstanden! Mach es öffentlich und lass mich weiter nach Matches suchen!\nErzähl mir jederzeit mehr Details.',
  aiChat_setPublicTitle: 'Öffentlich stellen',
  aiChat_setPublicMessage: 'Dein Inhalt wird für andere sichtbar, damit OctoSay passende Matches für dich findet.\n\nGeteilte Informationen:\n• Dein Nutzername und Avatar\n• Zusammenfassung deines Inhalts\n• Gesprächsinhalt (im Entdecken-Tab sichtbar)\n\nDu kannst es jederzeit wieder privat stellen.',
  aiChat_findMatches: 'Match-Ergebnis ansehen',
  aiChat_publishing: 'Wird veröffentlicht...',
  aiChat_matchSectionTitle: 'Deine Nachricht passt am besten in diese Gruppen – zum Posten antippen',
  aiChat_joinedBadge: 'Beigetreten',
  aiChat_matchSectionEmpty: 'Noch keine passenden Gruppen — erstelle einfach eine neue Gruppe und poste dort',
  aiChat_suggestPublishCreateNew: 'Neue Gruppe erstellen',
  aiChat_repickChannel: 'Gruppe wechseln',
  aiChat_creatingChannelTitle: 'Keine passende Gruppe gefunden — eine wird erstellt',
  aiChat_creatingChannelHint: 'Die KI erstellt eine Gruppe für deine Anfrage, danach geht es direkt zum Posten — meist 10–30 Sekunden',
  aiChat_publishToChannelHint: 'Wird in "{name}" gepostet',
  aiChat_pickChannelTitle: 'Wähle eine Gruppe zum Posten',
  aiChat_matchingChannelTitle: 'Passende Gruppe wird gesucht',
  aiChat_matchingChannelHint: 'Die KI sucht anhand deiner Anfrage — meist einige Sekunden bis zu einer halben Minute',
  aiChat_matchUnavailableTitle: 'Empfehlungen nicht verfügbar',
  aiChat_matchUnavailableHint: 'Suche unten eine Gruppe oder schließe und öffne die Veröffentlichung erneut',
  aiChat_waitSlowHint: 'Dauert länger als üblich, läuft aber weiter — warte noch kurz oder suche unten eine Gruppe',
  aiChat_creatingSlowHint: 'Die Gruppenerstellung dauert länger als üblich, läuft aber weiter — gleich geht es direkt zum Posten',
  aiChat_pickChannelEmptyHint: 'Keine passenden Gruppen gefunden. Erstelle eine neue Gruppe und poste dort',
  aiChat_loadMore: 'Mehr laden',
  sidebar_publish: 'Veröffentlichen',
  chat_selectLocationOnMap: 'Bitte wähle einen Ort auf der Karte',

  // App.vue new
  placeholder_email: 'E-Mail eingeben',
  placeholder_mobile: 'Handynummer eingeben',
  placeholder_password: 'Passwort eingeben',
  placeholder_name: 'Namen eingeben',
  random_nickname: 'Zufällig',
  placeholder_verification_code: 'Bestätigungscode eingeben',
  sending: 'Wird gesendet...',
  registering: 'Registrierung läuft...',
  send_code: 'Code senden',
  retry_in_seconds: 'Erneut versuchen in {countdown}s',
  toast_enter_email: 'Bitte E-Mail eingeben',
  toast_enter_mobile: 'Bitte Handynummer eingeben',
  toast_invalid_email: 'Bitte gültiges E-Mail-Format eingeben',
  toast_invalid_mobile: 'Bitte gültige Handynummer eingeben',
  toast_send_code_failed: 'Bestätigungscode konnte nicht gesendet werden',
  toast_code_sent: 'Bestätigungscode wurde an die E-Mail gesendet',
  toast_code_sent_sms: 'Bestätigungscode wurde an das Handy gesendet',
  toast_send_code_error: 'Bestätigungscode konnte nicht gesendet werden, bitte später erneut versuchen',
  toast_fill_all_fields: 'Bitte alle Felder ausfüllen',
  toast_login_failed: 'Anmeldung fehlgeschlagen',
  toast_login_success: 'Anmeldung erfolgreich',
  oauthOr: 'oder',
  toast_oauth_login_failed: 'Google-Anmeldung fehlgeschlagen',
  toast_oauth_login_error: 'Fehler bei der Google-Anmeldung, bitte erneut versuchen',
  toast_login_error: 'Anmeldung fehlgeschlagen, bitte später erneut versuchen',
  toast_register_failed: 'Registrierung fehlgeschlagen',
  toast_register_success: 'Registrierung erfolgreich',
  toast_register_error: 'Registrierung fehlgeschlagen, bitte später erneut versuchen',

  // AdBanner.vue
  ad: 'Werbung',

  // ContactAdGate.vue 联系前广告闸门
  contactAd_gateTitle: 'Bevor du dich verbindest',
  contactAd_gateSubtitle: 'Diese kurze Pause hält OctoSay kostenlos — danke für deine Unterstützung!',
  contactAd_waitBtn: 'Weiter in {sec}s',
  contactAd_continueBtn: 'Zum Chat weiter',

  // ChannelDetail.vue 私聊按钮
  session_privateChat: 'Chat',

  // AiMatch.vue
  ai_welcome_msg: 'Hi, ich bin AI. Sag mir, was du vorhast — Begleitung, Partner, Skill-Tausch oder ALLES andere.',
  default_username: 'Nutzer',

  // AvatarCropDialog.vue
  crop_hint: 'Zum Zoomen ziehen, zum Anpassen ziehen',
  toast_crop_failed: 'Bild zuschneiden fehlgeschlagen',

  // ChatBox.vue
  loading_match_info: 'Match-Info wird geladen...',
  view_match_details: 'Match-Details ansehen',
  step_clarify_needs: 'Klären',
  step_ai_matching: 'Im Gruppe posten',
  step_connect: 'KI-Matching',
  make_private: 'Privat stellen',
  setting: 'Wird eingestellt...',
  action_photo: 'Foto',
  action_file: 'Datei',
  action_video: 'Video',
  action_location: 'Standort',
  hint_get_app: 'Hol dir die App, um in Kontakt zu bleiben',
  match_finding_title: 'Deine Matches',
  match_finding_subtitle: 'AI matcht weiter für dich',
  match_time_hint: 'Dieser Vorgang dauert normalerweise 1-2 Minuten',
  match_result_stats: '{matched} beste Matches gefunden{interested}',
  match_tap_to_connect: 'Tippe, um dein Gespräch zu starten',
  match_channel_hint: 'Matche im Gruppe <strong>#{channel}</strong>. Same-Gruppe-Matches haben Vorrang, bei Bedarf können aber auch andere Gruppen einbezogen werden.',
  label_perfect_match: 'Bestes Match',
  label_worth_a_look: 'Ein Blick wert',
  match_no_result_title: 'Suche weiter nach Matches für dich',
  match_no_result_desc: 'Teile mehr Details, damit OctoSay die richtigen Matches findet. Installiere die App, um Benachrichtigungen zu erhalten, wenn dich jemand matcht.',
  go_back: 'Zurück',
  no_public_requirements: 'Noch keine öffentlichen Beiträge',
  channelEmpty_title: 'Hier ist es noch ruhig',
  channelEmpty_subtitle: 'Sei der Erste, der seine Gedanken teilt',
  channelEmpty_hint: "Schreib deine Gedanken auf und AI hilft dir beim Klären und beim Matching, damit deine Nachricht nicht untergeht",
  channelEmpty_action: 'Teile deine Gedanken',
  stay_connected: 'In Kontakt bleiben',
  download_app_desc: 'Hol dir die App zum Chatten und erhalte sofort Benachrichtigungen, wenn dich jemand kontaktiert!',
  app_store: 'App Store',
  google_play: 'Google Play',
  direct_apk: 'Direkte APK',
  match_history: 'Match-Verlauf',
  no_match_history: 'Noch kein Match-Verlauf',
  finding_matches: 'AI sucht weiter Matches für dich - Nach dem Posten einer Nachricht in einem Gruppe',
  discover_connect_hint: 'Du kannst mit ihnen chatten, sobald ihr gematcht seid!',
  match_initializing: 'Initialisierung...',
  placeholder_login_to_chat: 'melde dich an und erzähl mir, was du denkst',
  toast_need_clear: 'Deine Gedanken sind klar!',
  toast_ai_responding: 'AI antwortet, bitte warten...',
  toast_uploading_image: 'Bild wird hochgeladen, bitte warten...',
  toast_uploading_file: 'Datei wird hochgeladen, bitte warten...',
  toast_max_photos: 'Maximal {max} Fotos erlaubt',
  toast_uploading: 'Wird hochgeladen, bitte warten...',
  toast_file_too_large: '{name} überschreitet das 5MB-Limit',
  toast_video_too_large: '{name} überschreitet das 20MB-Limit',
  toast_video_processing: 'Video wird verarbeitet, bitte warten...',
  toast_upload_link_failed: 'Upload-Link konnte nicht abgerufen werden',
  analyzing_image: 'Bild wird analysiert...',
  toast_location_confirmed: 'Standort bestätigt',
  toast_location_selected: 'Standort ausgewählt',
  toast_enter_search: 'Bitte Suchbegriff eingeben',
  toast_search_failed: 'Suche fehlgeschlagen',
  toast_no_locations: 'Keine Orte gefunden',
  toast_search_error: 'Suche fehlgeschlagen, bitte erneut versuchen',
  toast_located_at: 'Gefunden bei: {address}',
  toast_shared_finding: 'Geteilt! Matches werden gesucht...',
  toast_update_failed: 'Update fehlgeschlagen',
  toast_set_private: 'Privat gestellt',
  toast_no_matches: 'Keine Matches gefunden',
  toast_matches_found: '{count} beste Matches gefunden',
  toast_start_conversation_first: 'Starte zuerst ein Gespräch',
  toast_load_history_failed: 'Match-Verlauf konnte nicht geladen werden',
  toast_ai_timeout: 'AI hat das Zeitlimit überschritten, bitte erneut versuchen',
  toast_message_blocked: 'Nachricht blockiert',
  network_disconnected: 'Netzwerk getrennt',
  toast_publish_success: 'Im Gruppe gepostet!',
  toast_publish_failed: 'Posten im Gruppe fehlgeschlagen',

  // ChatMsgList.vue
  collapse_thinking: 'Denkprozess einklappen',
  expand_thinking: 'Denkprozess ausklappen',
  thinking: 'denkt',
  select_date: 'Datum wählen',
  selected_location: 'Ausgewählter Standort',
  msg_blocked: 'Blockiert',
  retry: 'Erneut versuchen',
  msg_read: 'Gelesen',
  msg_sent: 'Gesendet',
  msg_unread: 'Ungelesen',
  label_start_datetime: 'Startdatum und -zeit:',
  label_end_datetime: 'Enddatum und -zeit:',
  toast_select_start_datetime: 'Bitte wähle Startdatum und -zeit',
  toast_end_before_start: 'Enddatum/-zeit kann nicht vor dem Start liegen',
  report_message: 'Nachricht melden',
  block_user: 'Nutzer blockieren',
  msg_revoke: 'Zurückziehen',
  msg_quote: 'Zitieren',
  msg_revoked_self: 'Du hast eine Nachricht zurückgezogen',
  msg_revoked_other: 'Die andere Partei hat eine Nachricht zurückgezogen',
  // Neutral text inside quote block: the revoker is the sender of the quoted message, unrelated to current message direction
  msg_revoked_generic: 'Nachricht zurückgezogen',
  // Platform removal (content moderation manual review), distinct from self-revoke
  msg_revoked_platform: 'Diese Nachricht wurde aufgrund eines Verstoßes von der Plattform zurückgezogen',
  msg_blocked_label: 'This message was blocked by the platform',
  toast_revoke_success: 'Nachricht zurückgezogen',
  toast_revoke_failed: 'Nachricht konnte nicht zurückgezogen werden',
  toast_load_data_failed: 'Daten konnten nicht geladen werden, bitte aktualisieren.',
  toast_file_url_missing: 'Datei-URL nicht gefunden',
  toast_block_success: 'Nutzer erfolgreich blockiert',
  toast_block_failed: 'Nutzer konnte nicht blockiert werden',

  // ChatSession.vue
  no_more_records: 'keine weiteren Einträge.',
  title_needs_clarified: 'Gedanken geklärt',
  title_clarifying: 'Deine Gedanken werden geklärt',
  title_public: 'Öffentlich',
  title_private: 'Privat',
  badge_clarified: 'Geklärt',
  badge_clarifying: 'Wird geklärt',
  badge_only_me: 'Nur ich',
  badge_expired: 'Abgelaufen',
  title_expired: 'Abgelaufen',
  no_chat_history: 'Kein Chatverlauf',

  // ContactMethods.vue
  block_status_banner: 'Du hast diesen Nutzer blockiert',
  unblock_user: 'Nutzer entblockieren',
  toast_block_missing_id: 'Blockieren nicht möglich: Nutzer-ID fehlt',
  dialog_block_confirm: 'Möchtest du {name} wirklich blockieren? Du erhältst keine Nachrichten mehr von dieser Person.',
  toast_user_blocked: '{name} wurde blockiert',
  toast_unblock_missing_id: 'Entblockieren nicht möglich: Nutzer-ID fehlt',
  toast_user_unblocked: '{name} wurde entblockiert',

  // BlockedUsers.vue
  blocked_users: 'Blockierte Nutzer',
  blocked_users_empty: 'Keine blockierten Nutzer',
  blocked_users_empty_hint: 'Blockierte Nutzer können dir keine Nachrichten mehr senden',
  blocked_users_unblock: 'Entblockieren',
  dialog_unblock_confirm: 'Nach dem Entblockieren kann die Person dir wieder Nachrichten senden.',
  toast_unblock_success: 'Entblockiert',
  toast_unblock_failed: 'Entblockieren fehlgeschlagen, bitte erneut versuchen',
  blocked_users_load_failed: 'Laden fehlgeschlagen. Tippen zum Wiederholen',
  blocked_users_blocked_at: 'Blockiert {date}',
  blocked_users_unknown_user: 'Unbekannter Nutzer',

  // Contacts.vue
  no_connections: 'Noch keine Nachrichten',
  chat_with: 'Mit {name} chatten',
  toast_load_contacts_failed: 'Kontakte konnten nicht geladen werden: {msg}',
  toast_load_contacts_error: 'Kontakte konnten nicht geladen werden. Bitte aktualisieren und erneut versuchen.',
  time_just_now: 'Gerade eben',
  time_minutes_ago: 'vor {min} Min.',
  time_hours_ago: 'vor {hour} Std.',
  time_days_ago: 'vor {day} Tg.',

  // InteractionNotification.vue
  interaction_notification_title: 'Benachrichtigungen',
  interaction_notification_subtitle: 'Kommentare & Gefällt mir',
  interaction_notification_empty: 'Noch keine Benachrichtigungen',
  interaction_notification_comment: 'kommentierte: {content}',
  interaction_notification_like: 'gefällt dein Beitrag',
  interaction_notification_reply: 'antwortete: {content}',
  interaction_notification_bookmark: 'hat deinen Beitrag gespeichert',
  toast_load_notifications_failed: 'Benachrichtigungen konnten nicht geladen werden: {msg}',
  toast_load_notifications_error: 'Benachrichtigungen konnten nicht geladen werden. Bitte aktualisieren und erneut versuchen.',
  mark_all_read: 'Alle als gelesen markieren',
  toast_mark_all_read_failed: 'Aktion fehlgeschlagen, bitte erneut versuchen',
  contacts_dnd: 'Benachrichtigungen stummschalten',
  dnd_enabled: 'Benachrichtigungen stummgeschaltet',
  dnd_disabled: 'Benachrichtigungen wieder aktiviert',
  dnd_action_enable: 'Stummschalten',
  dnd_action_disable: 'Stummschaltung aufheben',

  // Discover.vue
  toast_load_sessions_failed: 'Sitzungen konnten nicht geladen werden: {msg}',
  toast_load_sessions_error: 'Sitzungen konnten nicht geladen werden',
  discover_noMessages: 'Noch keine Nachrichten',

  // EmojiInputArea.vue
  placeholder_default: 'Teile mehr Details mit AI',
  userChat_typeMessage: 'Nachricht schreiben...',
  select_emoji: 'Emoji wählen',
  badge_new: 'neu',
  channel_search_placeholder: 'Kanal eingeben',
  channel_picker_empty: 'Kanal eingeben',

  // FrontPage.vue
  tab_chat_with_ai: 'Lass OctoSay dich verstehen',
  history_chats: 'Verlauf',
  tab_connections: 'Matches',
  tab_conversations: 'Nachrichten',
  tab_profile: 'Profil',
  new_session: 'Neu',
  history_tab_chats: 'Meine',
  history_tab_matches: 'Matches',
  channels_octosay: 'Octo-Gruppen',
  tab_matches: 'Matches',
  tab_messages: 'Nachrichten',

  // Header.vue
  slogan: 'OctoSay - Die KI, die dich versteht und dich mit der richtigen Person verbindet',
  app_name: 'OctoSay',
  slogan_short: 'Die KI, die dich versteht und dich mit der richtigen Person verbindet',
  slogan_ai: 'Die KI, die dich versteht und dich mit der richtigen Person verbindet',
  get_the_app: 'App holen',
  desc_iphone_ipad: 'iPhone / iPad',
  desc_android: 'Android',
  search_in_app_stores: 'oder suche OctoSay in den App Stores',

  // MapLocationPicker.vue
  placeholder_search_location: 'Ort suchen...',
  coords_display: 'Längengrad: {lng}, Breitengrad: {lat}',
  toast_no_geolocation: 'Dein Browser unterstützt keine Geolokalisierung',
  toast_location_permission_denied: 'Standort konnte nicht ermittelt werden, bitte Standortberechtigungen prüfen',
  loading_address: 'Adresse wird geladen...',

  // MatchedSession.vue
  created_at: 'Erstellt: {time}',
  ai_match_analysis: 'AI Match-Analyse',
  error_missing_session_params: 'Erforderliche Sitzungsparameter fehlen',
  match_private_hint: 'Diese Sitzung ist privat. Inhalt nicht verfügbar',

  // PersonalCenter.vue
  label_name: 'Name:',
  placeholder_enter_name: 'Namen eingeben',
  label_bio: 'Bio:',
  placeholder_enter_bio: 'Schreibe etwas über dich',
  placeholder_bio_empty: 'Sag etwas über dich',
  bio: 'Bio',
  delete_account: 'Konto löschen',
  delete_warning: 'Diese Aktion kann nicht rückgängig gemacht werden.',
  delete_data_intro: 'Folgende Daten werden endgültig gelöscht:',
  delete_item_profile: 'Deine Profilinformationen',
  delete_item_chat: 'Chatverlauf und Sitzungen',
  delete_item_contact: 'Kontaktinformationen',
  delete_item_all: 'Alle zugehörigen Daten',
  final_confirmation: 'Letzte Bestätigung',
  delete_confirm_prompt: 'Tippe "delete" zur Bestätigung:',
  placeholder_type_delete: 'delete eingeben',
  private_token: 'Privates Token',
  token_desc: 'Token für API-Zugriff generieren',
  toast_not_logged_in: 'Nutzer nicht angemeldet',
  toast_name_required: 'Name ist erforderlich',
  toast_save_success: 'Erfolgreich gespeichert',
  toast_save_failed: 'Speichern fehlgeschlagen',
  toast_image_too_large: 'Bild überschreitet das 5MB-Limit',
  toast_avatar_updated: 'Avatar aktualisiert',
  toast_avatar_failed: 'Avatar konnte nicht aktualisiert werden',
  toast_upload_failed: 'Upload fehlgeschlagen',
  toast_token_generated: 'Token generiert',
  toast_token_failed: 'Token konnte nicht generiert werden',
  toast_copied: 'In die Zwischenablage kopiert',
  toast_copy_failed: 'Kopieren fehlgeschlagen',
  toast_account_deleted: 'Konto erfolgreich gelöscht',
  toast_delete_account_failed: 'Konto konnte nicht gelöscht werden',
  toast_logout_success: 'Abmeldung erfolgreich',
  toast_logout_failed: 'Abmeldung fehlgeschlagen',
  profile_tab_messages: 'Nachrichten',
  profile_tab_comments: 'Kommentare',
  profile_tab_likes: 'Gefällt mir',
  profile_tab_bookmarks: 'Gespeichert',
  profile_empty_messages: 'Noch keine Nachrichten',
  profile_empty_comments: 'Noch keine Kommentare',
  profile_empty_likes: 'Noch keine Gefällt-mir',
  profile_empty_bookmarks: 'Noch nichts gespeichert',
  profile_reply_to: 'Antwort an {name}',
  profile_stats_posts: 'Nachrichten',
  profile_stats_comments: 'Kommentare',
  profile_stats_likes: 'Erhaltene Gefällt-mir',
  profile_joined: 'Beigetreten {date}',

  // ReportDialog.vue
  report_message_title: 'Nachricht melden',
  report_reason_prompt: 'Bitte wähle einen Grund für die Meldung dieser Nachricht:',
  report_spam: 'Spam',
  report_harassment: 'Belästigung oder Mobbing',
  report_inappropriate: 'Unangemessener Inhalt',
  report_other: 'Sonstiges',
  placeholder_report_desc: 'Beschreibe das Problem (optional)',
  toast_select_reason: 'Bitte wähle einen Grund',
  toast_report_success: 'Meldung erfolgreich gesendet',
  toast_report_failed: 'Meldung konnte nicht gesendet werden',

  // common.js
  ellipsis: '..',

  // ChatBox.vue / ChatMsgList.vue message summary prefixes
  summary_image: '[Bild]',
  summary_images: '[Bild×{count}]',
  summary_file: '[Datei]',
  summary_files: '[Dateien×{count}]',
  summary_video: '[Video]',
  summary_videos: '[Videos×{count}]',
  summary_location: '[Standort]',
  summary_locations: '[Standorte×{count}]',
  summary_emoji: '[Emoji]',
  summary_emojis: '[Emojis×{count}]',
  summary_voice: '[Sprachnachricht]',
  summary_voices: '[Sprachnachrichten×{count}]',
  summary_mixed: '[Gemischt]',
  summary_other: '[Sonstiges]',

  // Voice messages
  voice: 'Sprachnachricht',
  voice_recording: 'Aufnahme...',
  toast_voice_too_short: 'Aufnahme zu kurz',
  toast_voice_failed: 'Sprachnachricht konnte nicht gesendet werden',
  toast_mic_permission_denied: 'Kein Zugriff aufs Mikrofon. Bitte in den Browsereinstellungen aktivieren',
  toast_recording_not_supported: 'Sprachaufnahme wird in diesem Browser nicht unterstützt',
  voice_load_failed: 'Sprachnachricht konnte nicht geladen werden',

  // Expire At
  aiChat_expireLine: "Gültig bis {date}, sag AI jederzeit Bescheid zum Aktualisieren",
  aiChat_expireExpired: "Der Inhalt ist abgelaufen und für andere nicht mehr sichtbar. Sag AI jederzeit Bescheid, um das Ablaufdatum zu aktualisieren",

  // MatchedSession.vue
  detail: 'Detail',

  // Match notification hints
  match_new_result_hint: 'Bei neuen Match-Ergebnissen wirst du per E-Mail benachrichtigt. Für ein besseres Erlebnis installiere die App und erhalte sofortige Benachrichtigungen.',

  // Match notification hints
  match_connection_notify_hint: 'Match gefunden und benachrichtigt! Geh und sag hi!',
  match_continuousMatching: "AI matcht kontinuierlich für dich",
  match_continuousMatchingHint: 'Wir sagen dir sofort Bescheid, sobald es neue Matches gibt',
  match_continuousMatchingOthers: "AI matcht kontinuierlich für sie",
  match_continuousMatchingOthersHint: 'Neue Matches erscheinen hier, sobald sie gefunden sind',
  match_noResultsTitleOthers: 'Suche weiter nach Matches',
  match_noResultsHintOthers: "AI matcht kontinuierlich für sie. Ergebnisse erscheinen hier, sobald sie gefunden sind.",
  match_newMatchFound: '{n} neue Matches gefunden!',
  match_worth_exploring_hint: 'Du entscheidest, ob du dich meldest.',

  // Matches filter tags
  filter_all: 'Alle',
  filter_best_connection: 'Bestes Match',
  filter_worth_a_look: 'Ein Blick wert',

  // LandingPage.vue (CN Portal)
  landing_brand_slogan: 'OctoSay - Die KI, die dich versteht und dich mit der richtigen Person verbindet',
  landing_hero_title: 'Schreibe in deinen Gruppe — AI klärt zuerst, dann veröffentlichst du und wirst gematcht.',
  landing_hero_subtitle: 'Schreibe die Nachricht, die du teilen möchtest, in einen Octo-Gruppe. Bevor sie live geht, chattet AI mit dir, um die Details festzuzurren. Nach deiner Bestätigung werden Nachricht und KI-Zusammenfassung zusammen gepostet, und AI beginnt mit dem Matching.',
  landing_download_on: 'Laden im',
  landing_get_it_on: 'Erhältlich im',
  landing_direct_download: 'Direkter Download',
  landing_how_title: 'So funktioniert es',
  landing_step1_title: 'Im Gruppe schreiben',
  landing_step1_desc: 'Schreibe die Nachricht, die du teilen möchtest, in den Gruppe. Die KI chattet zuerst mit dir, um die Details zu klären, sodass jeder Beitrag klar, nützlich und match-fähig ist — nicht im Lärm untergeht.',
  landing_step2_title: 'Bestätigen, posten & Match bekommen',
  landing_step2_desc: 'Bei deiner Bestätigung werden deine Original-Nachricht und die KI-Zusammenfassung zusammen in den Gruppe gepostet. Danach sucht die KI kontinuierlich deine besten Matches, damit dein Beitrag nicht untergeht oder ignoriert wird.',
  landing_step3_title: 'Verbinden & chatten',
  landing_step3_desc: 'Bei einem Match sehen beide Seiten die Chat-Historie des jeweils anderen mit AI und die KI-Zusammenfassung. Mit gemeinsamem Kontext fällt das Ankommen leicht — einfach natürlich chatten.',
  // Comparison Section
  landing_comparison_title: 'Warum OctoSay?',
  landing_comparison_subtitle: 'Gruppe-Chat, aber AI klärt deine Details und matcht dich aktiv.',
  landing_comparison_other: 'Discord',
  landing_comparison_octo: 'OctoSay',
  landing_cmp1_label: 'Inhaltsqualität',
  landing_cmp1_other: 'Spam-, Werbe- und Off-Topic-Fluten',
  landing_cmp1_octo: 'Nur von der KI kuratierte Bedarfskarten',
  landing_cmp2_label: 'Menschen finden',
  landing_cmp2_other: 'Posten und einfach auf Antworten warten',
  landing_cmp2_octo: 'AI matcht dich aktiv',
  landing_cmp3_label: 'Geräuschpegel',
  landing_cmp3_other: 'Hunderte Nachrichten zum Durchscrollen',
  landing_cmp3_octo: 'Null Lärm, jeder Beitrag zählt',
  landing_cmp4_label: 'Einstieg',
  landing_cmp4_other: 'Server suchen, Kanäle durchstöbern, dich selbst reinfuchsen',
  landing_cmp4_octo: 'Tippe im Gruppe; AI klärt und matcht',
  landing_cmp_other_wechat: 'WeChat',
  landing_cmp_other_xhs: 'Xiaohongshu',
  landing_cmp_other_facebook: 'Facebook',
  landing_cmp_other_reddit: 'Reddit',
  landing_cmp1_wechat: 'Gruppenchats geflutet mit Werbung & Spam',
  landing_cmp1_xhs: 'Werbeposts überall, schwer zu vertrauen',
  landing_cmp1_facebook: 'Werbung und Klickbait fluten deinen Feed',
  landing_cmp1_reddit: 'Spam und Off-Topic-Beiträge überall',
  landing_cmp2_wechat: 'Nur über Kontakte und Gruppeneinladungen',
  landing_cmp2_xhs: 'Selbst suchen und Beiträge wühlen',
  landing_cmp2_facebook: 'Beschränkt auf vorhandene Freunde & Gruppen',
  landing_cmp2_reddit: 'Selbst durch Subreddits stöbern und auf Antworten hoffen',
  landing_cmp3_wechat: 'Hunderte Gruppen-Nachrichten scrollen',
  landing_cmp3_xhs: 'Feed voller Empfehlungen und Werbung',
  landing_cmp3_facebook: 'Endlose empfohlene Beiträge & Werbung',
  landing_cmp3_reddit: 'Hunderte Kommentare zum Durchscrollen',
  landing_cmp5_label: 'Wer sucht',
  landing_cmp5_wechat: 'Einzeln nachfragen, auf Glück hoffen',
  landing_cmp5_xhs: 'Posten, auf Kommentare warten, selbst filtern',
  landing_cmp5_facebook: 'Du musst in Gruppen herumfragen',
  landing_cmp5_reddit: 'Posten, auf Antworten warten, dann filtern',
  landing_cmp5_octo: 'Die KI findet automatisch weiter Menschen für dich',

  landing_features_title: 'Kernfunktionen',
  landing_feature1_title: 'Vor dem Posten klären',
  landing_feature1_desc: 'Keine Formulare. Schreibe deine Nachricht in den Gruppe und AI chattet zuerst mit dir, stellt die richtigen Fragen und versteht wirklich, was du brauchst.',
  landing_feature2_title: 'Sauber, nicht chaotisch',
  landing_feature2_desc: 'Deine Nachricht und die KI-Zusammenfassung werden zusammen gepostet — OctoSay kuratiert jeden Beitrag, also kein Spam, kein Off-Topic-Flut, kein Rauschen zum Durchscrollen.',
  landing_feature3_title: 'Proaktives Matching',
  landing_feature3_desc: 'Sobald du bestätigst und dein Beitrag + KI-Zusammenfassung live sind, durchsucht AI kontinuierlich den Gruppe nach Menschen, die zu deiner Suche passen — und erklärt warum.',
  landing_feature4_title: 'Themen-Communities, Null Lärm',
  landing_feature4_desc: 'Tritt Themen-Gruppen bei — Sport, Gaming, Sprachaustausch, Mitbewohner — AI klärt deine Nachricht vor dem Posten, damit jeder Gruppe sauber und nützlich bleibt.',
  landing_feature5_title: 'Datenschutz',
  landing_feature5_desc: 'Du kannst Nachrichten nach dem Senden privat stellen, nur für dich sichtbar. Volle Kontrolle.',
  landing_feature6_title: 'Bedeutsame Gespräche',
  landing_feature6_desc: 'Kein Lärm, keine Ablenkung — jede Nachricht zählt.',
  landing_usecases_title: 'Für jedes Szenario',
  landing_usecases_subtitle: 'Was auch immer du vorhast, tritt einem Themen-Gruppe bei — AI übernimmt das Matching, damit du nicht scrollen und suchen musst',
  landing_usecase_game: 'Gaming-Begleitung',
  landing_usecase_language: 'Sprachaustausch',
  landing_usecase_skill: 'Skill-Tausch',
  landing_usecase_roommate: 'Mitbewohner finden',
  landing_usecase_travel: 'Reisebegleitung',
  landing_usecase_sports: 'Sport-Partner',
  landing_usecase_study: 'Lern-Partner',
  landing_usecase_anything: '...oder teile alles',
  landing_cta_title: 'Bereit loszulegen?',
  landing_cta_desc: 'Tritt einem Themen-Gruppe bei, schreib, was du teilen möchtest, lass AI die Details klären, dann veröffentliche und matche mit den richtigen Leuten.',
  landing_use_now: 'Jetzt nutzen',
  landing_groups: 'Gruppen',

  // OnboardingPage.vue
  onboarding_skip: 'Überspringen',
  onboarding_next: 'Weiter',
  onboarding_getStarted: 'Loslegen',
  onboarding_step1Title: "Sag in der Gruppe, was du brauchst",
  onboarding_step1Desc: "Wonach du auch suchst oder was du tun möchtest — sag es einfach. Die KI chattet mit dir, um die Details zu klären, und macht daraus ein klares Anliegen.",
  onboarding_step2Title: 'Bestätigen, posten & Match bekommen',
  onboarding_step2Desc: "Sobald deine Nachricht im Gruppe gepostet ist, findet die KI kontinuierlich deine besten Matches, damit deine Nachricht nicht untergeht oder ignoriert wird.",
  onboarding_step3Title: 'Verbinden & chatten',
  onboarding_step3Desc: "Beide Seiten sehen den Chat des anderen mit AI und wissen, was der andere sucht. Mit dem gemeinsamen Kontext ist der Einstieg ganz einfach – einfach natürlich chatten.",

  // ChannelDetail.vue
  channel_image_limit: 'Max. 1 Bild',

  // ChannelMembers.vue
  channel_members_empty: 'Noch keine Mitglieder',
  channel_members_title: 'Mitglieder',
  channel_role_owner: 'Inhaber',
  channel_role_admin: 'Admin',
  channel_role_member: 'Mitglied',

  // Settings.vue
  settings_language: 'Sprache',
  settings_language_followSystem: 'System folgen',

  // ChatBox.vue
  match_interested_suffix: ', {count} einen Blick wert',

  // ChatBox.vue - Phasen des KI-Matching-Fortschritts
  match_stage_fetch_chat: 'Unterhaltung wird abgerufen',
  match_stage_query_expansion: 'Abfragen werden erweitert',
  match_stage_semantic_search: 'Semantische Suche',
  match_stage_deep_search: 'Tiefenanalyse',
  match_stage_rerank: 'Intelligentes Matching',
  match_stage_refining: 'Ergebnisse werden optimiert',
  match_stage_fetch_details: 'Details werden abgerufen',

  // ChannelDetail.vue - Bild-Upload
  channel_select_image: 'Bitte wähle eine Bilddatei aus',
  channel_image_upload_failed: 'Bildupload fehlgeschlagen, bitte erneut versuchen',
  chatInput_channelSearchHint: "Gruppe suchen",
}



// WEBPACK FOOTER //
// ./src/i18n/de.js